import { inject, InjectionKey, provide, ref, Ref } from 'vue'

export const GeneratorIdInjectionKey: InjectionKey<Ref<string>> = Symbol('GeneratorIdInjectionKey')

export const useGeneratorId = () => inject(GeneratorIdInjectionKey) ?? ref('')

export const provideGeneratorId = (generatorId: Ref<string>) => provide(GeneratorIdInjectionKey, generatorId)
